module.exports = __webpack_public_path__ + "asset/image-iconCategoryBalanceUpdate-f7fd9b0f71882e3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/application/component/category-icon/image/iconCategoryBalanceUpdate.svg
// module id = ACBE
// module chunks = 0